import { Grid,  Stack } from '@mui/material';
import { DashboardCounterSkeleton } from '../../skeleton-components/dashboard-counter-skeleton';
import { BarChartSkeleton } from '../../skeleton-components/bar-chart-skeleton';
import { DonutChartSkeleton } from '../../skeleton-components/donut-chart-skeleton';

export const AnalyticsByEnergySkeleton = () => (
  <Grid container spacing={2}>
    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
      <DashboardCounterSkeleton height={100} />
    </Grid>
    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
      <DashboardCounterSkeleton height={100} />
    </Grid>
    <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
      <DashboardCounterSkeleton height={100} />
    </Grid>

    <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
      <Stack spacing={2}>
        <DonutChartSkeleton height={420} />
      </Stack>
    </Grid>

    <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
      <BarChartSkeleton height={420} />
    </Grid>
  </Grid>
);
